import * as React from "react";
import styled from "styled-components";
import checked from "../../assets/img/icons/checked_form.svg";
import theme from "../../assets/css/theme";

const Checkbox = styled.input`
	display: none;
`;

const Label = styled.label`
	transition: 0.4s;
	display: inline-block;
	padding-left: 3em;
	position: relative;
	line-height: 1.1em;
	font-weight: 500;
	color: #434343;

	vertical-align: baseline;
	text-align: left;
	box-sizing: border-box;
	font-size: 11px;

	&:before {
		position: absolute;
		left: 0;
		top: 12px;
		display: block;
		content: "";
		border: 1px solid ${theme.form_elements_color};
		box-sizing: border-box;
		transform: translateY(-50%);
		border-radius: 2px;
		width: 16px;
		height: 16px;

		${Checkbox}:checked + & {
			background-image: url(${checked});
			background-size: 1em;
			background-repeat: no-repeat;
			background-position: center;
		}
	}

	a {
		color: #434343;
	}
`;

const onChange = () => null;

interface IProps {
	name: string;
	is_checked?: boolean;
	value?: string;
}

export const CheckboxStyled = ({name, is_checked, value = "1"}: IProps) => (
	<React.Fragment>
		<Checkbox
			type="checkbox"
			name={name}
			id={name}
			value={value}
			checked={is_checked}
			onChange={onChange}
		/>
		<Label htmlFor={name} />
	</React.Fragment>
);

export default CheckboxStyled;
